import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AppRouter } from './router'
import './styles/tokens.css'
import './styles/app.css'

const container = document.getElementById('root')
if (!container) throw new Error('index.html 缺少 #root 挂载点')

createRoot(container).render(
  <StrictMode>
    <AppRouter />
  </StrictMode>,
)
